/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 12.06.24
 *
 */
import BaseEntryObjectData from "@shared/Workflow/base/ObjectData/BaseEntryObjectData";
import TagItem from "@shared/Tags/TagItem";
import {Type} from "@qwoach/class-transformer-wrapper"

export default class ClientEntryObjectData extends BaseEntryObjectData {

	note: string = null
	noteUpdateAt: number = null

	@Type(() => TagItem)
	tagItemsArray: TagItem[] = []

	constructor() {
		super();
	}

	setNoteMessage(messageStr){
		this.note = messageStr
		this.noteUpdateAt = new Date().getTime()
		return this
	}

	hasNote(){
		return this.note !== null
	}

	getNoteMessage(){
		return this.hasNote() ? this.note : ""
	}


}
